import React from 'react';
/* import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official' */
import { Doughnut } from 'react-chartjs-2';
import { useNavigate } from "react-router-dom";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
//import { Pie } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend);
function MismatchesdDonuts({MismatchesData,dataFromChild3}) {
  let navigate = useNavigate(); 
    const percentage_pending = ((MismatchesData?.pending_mismatch/MismatchesData?.total_mismatch)*100).toFixed(2);
    const percentage_completed = ((MismatchesData?.approved_disapproved_matched/MismatchesData?.total_mismatch)*100).toFixed(2);
    const data = {
        labels: ['% Mismatched','% Approved/Disapproved' ],
        datasets: [
          {
            data: [(percentage_pending),(percentage_completed)],
            backgroundColor: [
              'rgb(217, 217, 217)',
                'rgb(26, 156, 244)',

            ],
            borderColor: [
              'rgb(217, 217, 217)',
             'rgb(26, 156, 244)',

            ],
            borderWidth: 1,
          },
        ],
      };

    const options = {
      cutout: '70%',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
          legend: {
              display: false
          },
          
      },
      onClick: (e, activeEls) => {
        let dataIndex = activeEls[0]?.index;
        let label = e.chart.data.labels[dataIndex];
        navigateMe(label)
      },
      onHover: (event, chartElement) => {
        let dataIndex = chartElement[0]?.index;
        if(event.chart.data.labels[dataIndex] === '% Mismatched'){
          event.native.target.title = 'Click to view mismatches'
          event.native.target.style.cursor = 'pointer'
        }
        else{
          event.native.target.title = ''
          event.native.target.style.cursor = 'default'
        }
        
      }
    };

    function navigateMe(label){
      //console.log(label);
      if(label === '% Mismatched'){
        navigate('/mismatches-by-status?status=pending&mismatches_list_page_no=1&analyst='+dataFromChild3.analyst+'&batch='+dataFromChild3.batch+'&category='+dataFromChild3.category+'&client='+dataFromChild3.client+'&datefrom='+dataFromChild3.datefrom+'&dateto='+dataFromChild3.dateto+'&field='+dataFromChild3.field+'&invoice='+dataFromChild3.invoice+'&invoice_status='+dataFromChild3.invoice_status+'&vendor='+dataFromChild3.vendor+'');
      }
      
    }

    let plugin = [];

    if(percentage_completed >= 0){
        plugin = [{
          afterDraw: function(chart) {
            //chart.destroy();
            var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;
            ctx.restore();
            var fontSize = (height / 300).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "top";
            var text = '',
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;
            ctx.fillStyle = 'rgb(26, 156, 244)';
            ctx.fillText(text, textX, textY);
            ctx.save();
          } 
      }]
    }

	return (
		<>
			<h1 className="text-lg font-black text-primary">Mismatches</h1>
			<p className="text-xs text-gray-500 mb-2">Total fields mismatches</p>
			<div className="pt-4">
      {MismatchesData?.total_mismatch > 0 ? (
        <Doughnut width={300} height={300} options={options} data={data} plugins={plugin} redraw={true}/>
      ) : (
        <div  className='min-h-[150px]'>
            No Data Found
        </div> 
      )}
        
			</div>
		</>
	);
}

export default MismatchesdDonuts;